import React from 'react';

export function NewCustomerModal({ isOpen, onClose, customerForm, setCustomerForm, handleCreateCustomer }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-slate-800 p-6 rounded-lg w-full max-w-md border border-slate-700">
        <h2 className="text-lg font-semibold mb-5 text-slate-100">Add New Customer</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm mb-1 text-slate-400">Display Name *</label>
            <input
              type="text"
              placeholder="Customer's Company Name"
              className="w-full p-2 bg-slate-900 rounded border border-slate-700 focus:outline-none focus:border-slate-600 text-slate-100 placeholder-slate-500"
              value={customerForm.displayName}
              onChange={(e) => setCustomerForm({ ...customerForm, displayName: e.target.value })}
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm mb-1 text-slate-400">Contact Email *</label>
            <input
              type="email"
              placeholder="contact@customer.com"
              className="w-full p-2 bg-slate-900 rounded border border-slate-700 focus:outline-none focus:border-slate-600 text-slate-100 placeholder-slate-500"
              value={customerForm.email}
              onChange={(e) => setCustomerForm({ ...customerForm, email: e.target.value })}
            />
          </div>
          <div className="flex justify-end gap-3 pt-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-slate-700 rounded hover:bg-slate-600 text-slate-200 transition-colors text-sm"
            >
              Cancel
            </button>
            <button
              onClick={handleCreateCustomer}
              className="px-4 py-2 bg-indigo-600 rounded hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white font-medium text-sm"
              disabled={!customerForm.displayName || !customerForm.email}
            >
              Create Customer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
